/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2025-11-07 14:16:42
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/index.scss'
import ElementUI from 'element-ui';
import '@/assets/style/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css';
import * as Api from '@/api'
// import  '@/assets/js/agent.vue.min.js'
import './utils/directive.js'
import { lang } from '@/utils/filters'
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$API = Api
Vue.prototype.$lang = lang

function initCaptchaSDK() {
  if (window.initCaptcha) {
    try {
      const CaptchaSDK = window.initCaptcha({
        appKey: '189931554', // 腾讯验证码 appKey（必填）
        isCaptchaOpen: async function() {
          try {
            const { data, code } = await Api.isShowSlider()
            console.log('接口返回:', data)
            if (code === 1) {
              return data || false
            }
            return true
          } catch (error) { return true }
        }
      })
      window.CaptchaSDK = CaptchaSDK
    } catch (error) {
      // 容灾：创建模拟 SDK，确保业务继续运行
      window.CaptchaSDK = { init: function(callback) { const savedCallback = callback; return { show: function() { if (savedCallback && typeof savedCallback === 'function') { savedCallback({ ret: 0, ticket: 'fallback_ticket', randstr: 'fallback_randstr' }) } }, destroy: function() {} } }, enable: function() {}, disable: function() {} }
    }
  } else {
    // 容灾：如果 SDK 未加载，创建模拟 SDK，确保业务继续运行
    console.warn('⚠️ 验证码 SDK 未加载，使用容灾模式（直接返回成功）')
    window.CaptchaSDK = { init: function(callback) { const savedCallback = callback; return { show: function() { if (savedCallback && typeof savedCallback === 'function') { savedCallback({ ret: 0, ticket: 'fallback_ticket', randstr: 'fallback_randstr' }) } }, destroy: function() {} } }, enable: function() {}, disable: function() {} }
  }
}

// 先初始化 SDK，再创建 Vue 实例
initCaptchaSDK()

router.beforeEach((to, from, next) => {
	if(to.path === '/login' && from.path !== '/register') {
		sessionStorage.setItem('lastRouter', from.path)
	}
  next()
})
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
